import { configureStore } from "@reduxjs/toolkit";
import visibleReducer from "../features/sidebar/sidebar";
import myreportReducer from "../features/my-report";
import permissionReducer from "../features/permission";

export const store = configureStore({
  reducer: {
    visible: visibleReducer,
    myreport: myreportReducer,
    permission: permissionReducer,
  },
});
